import * as dayjs from 'dayjs'
import * as isLeapYear from 'dayjs/plugin/isLeapYear' // import plugin
import * as duration from 'dayjs/plugin/duration' // import plugin
import * as relativeTime from 'dayjs/plugin/relativeTime' // import plugin
import 'dayjs/locale/it' // import locale

dayjs.extend(isLeapYear)
dayjs.extend(duration)
dayjs.extend(relativeTime)
dayjs.locale('it')

window.dayJs = dayjs